// Rails UJS bootstrap — только один раз на страницу (application.js и landing_2025.js оба тянут этот модуль)
import Rails from '@rails/ujs'

if (!window._rails_loaded) {
  Rails.start()
}
